import { useLocation } from "react-router-dom";
import { SHOP_SOURCES } from "./constants/shopSources";
import { deriveAppBase } from "./appBase";

export const getFullPath = (location) => location.pathname + location.search;

export const useDetailPageQuery = (idQueryKey = null) => {
    const location = useLocation();

    if (!idQueryKey) return location.search.slice(1);

    const queryParams = new URLSearchParams(location.search);
    // Any `source` value is passed straight through to the external-commerce endpoint (the
    // available sources are backend-driven, same as the admin picker). Only an absent source
    // defaults to JCR — no client-side allow-list to maintain per connector.
    const source = queryParams.get("source") || SHOP_SOURCES.JCR;

    return {
        id: queryParams.has(idQueryKey) ? queryParams.get(idQueryKey) : null,
        source,
    };
};

export const useIsHomePage = () => {
    const location = useLocation();

    // "Home" means: the path IS its own site base — a shop's root page or the legacy base.
    return location.pathname === deriveAppBase(location.pathname);
};
